import { render, staticRenderFns } from "./AfterGrace.vue?vue&type=template&id=2bf4d121&scoped=true"
import script from "./AfterGrace.vue?vue&type=script&lang=js"
export * from "./AfterGrace.vue?vue&type=script&lang=js"
import style0 from "./AfterGrace.vue?vue&type=style&index=0&id=2bf4d121&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf4d121",
  null
  
)

export default component.exports